import cn from "classnames"
import { Checkbox as CB } from "flowbite-react"
import { forwardRef } from "react"

interface ICheckBox {
  name: string
  onSelect?: any
  className?: string
  checked?: boolean
}

const Checkbox = forwardRef(({ name, className, onSelect, checked }: ICheckBox, ref: any) => {
  return <CB ref={ref} name={name} className={cn("cursor-pointer", className)} onChange={onSelect} checked={checked} />
})

export default Checkbox
